import './portfolio-color.scss';
import { PortfolioDetailData } from '@/data/portfolio/portfolio-detail-data';
import { motion, useInView } from 'motion/react';
import { useRef } from 'react';

type Props = {
	color: PortfolioDetailData['color'];
};

const PortfolioColor = ({ color }: Props) => {
	const { point, sub1, sub2, sub3, sub4 } = color;
	const ref = useRef<HTMLDivElement>(null);
	const inView = useInView(ref, { once: true, margin: '0px 0px -200px 0px' });
	const ref2 = useRef<HTMLDivElement>(null);
	const inView2 = useInView(ref2, {
		once: true,
		margin: '0px 0px -100px 0px'
	});

	const subColorArray = [sub1, sub2, sub3, sub4];

	return (
		<div className="portfolio-color-wrapper" ref={ref}>
			<motion.section
				className="point-color-section"
				initial={{ opacity: 0 }}
				animate={inView ? { opacity: 1 } : { opacity: 0 }}
				transition={{ duration: 0.8, ease: 'easeOut' }}
				style={{
					backgroundColor: point.hex,
					color: point.textColor
				}}
			>
				<h5>Point</h5>
				<p>{point.hex.toLocaleUpperCase()}</p>
			</motion.section>
			<section className="sub-color-section" ref={ref2}>
				{subColorArray.map((subColor, index) => (
					<motion.article
						key={index}
						className="sub-color-section-item"
						initial={{ opacity: 0 }}
						animate={inView2 ? { opacity: 1 } : { opacity: 0 }}
						transition={{
							duration: 0.8,
							ease: 'easeOut',
							delay: 0.3 + index * 0.1
						}}
						style={{
							backgroundColor: subColor.hex,
							color: subColor.textColor
						}}
					>
						<h5>Sub</h5>
						<p>{subColor.hex.toLocaleUpperCase()}</p>
					</motion.article>
				))}
			</section>
		</div>
	);
};

export default PortfolioColor;
